export const DIALOG_SIZES = {
    SMALL_WIDTH: 600,
    LARGE_WIDTH: 1120,
    FULL_WIDTH: '80vw',
    SMALL_HEIGHT: 256,
    LARGE_HEIGHT: 528,
    FULL_HEIGHT: '80vh'
};
